/*
  Page « Mon devis » (sections/sesames-devis.liquid), qui remplace l'application Samita (octobre 2026).
  1. Sélection : lignes modifiables (quantité, retrait), lues dans window.SesamesDevis (assets/sesames-devis-liste.js).
  2. Calcul : prix, TVA et frais de port demandés au relais des devis (POST /calcul) pour le pays de livraison.
  3. Envoi : contrôle des champs, jeton anti-robots (Cloudflare Turnstile), puis POST /devis ; le relais crée la
     commande provisoire et renvoie les données du devis. Sans jeton au bout de 10 secondes (vérification qui n'aboutit
     pas, par exemple sous Firefox 157-158 ou Safari 26), la demande part quand même avec les codes d'erreur de
     Turnstile : le relais fait alors un devis de secours, dans la limite d'un plafond par jour.
  4. PDF : fabriqué dans le navigateur avec jsPDF (cdnjs, version figée et empreinte d'intégrité).
  5. Relecture : ?devis=<id>&cle=<clé> (lien de l'e-mail) affiche le devis et permet de retélécharger le PDF.
  Si le relais ne répond pas, la page propose d'envoyer la liste par e-mail.
*/
(() => {
  const demarrer = () => {
    const racine = document.querySelector('[data-s-devis-page]');
    if (!racine || racine.dataset.sDevisPret) return;
    racine.dataset.sDevisPret = '1';
    if (!window.SesamesDevis) {
      const chargement = racine.querySelector('[data-s-devis-chargement]');
      if (chargement) chargement.textContent = 'La page de devis n’a pas pu se charger. Rechargez la page.';
      return;
    }
    pageDevis(racine);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
  document.addEventListener('shopify:section:load', demarrer);

  function pageDevis(racine) {
    const Devis = window.SesamesDevis;
    let R = {};
    try {
      R = JSON.parse(racine.querySelector('[data-s-devis-reglages]').textContent);
    } catch (erreur) { /* réglages illisibles : valeurs par défaut */ }
    R.email = R.email || 'edition@editions-sesames.com';

    const q = (selecteur, base = racine) => base.querySelector(selecteur);
    const qa = (selecteur, base = racine) => Array.from(base.querySelectorAll(selecteur));
    const el = {
      chargement: q('[data-s-devis-chargement]'),
      vide: q('[data-s-devis-vide]'),
      dernier: q('[data-s-devis-dernier]'),
      resultat: q('[data-s-devis-resultat]'),
      grille: q('[data-s-devis-grille]'),
      lignes: q('[data-s-devis-lignes]'),
      modele: q('[data-s-devis-modele-ligne]'),
      form: q('[data-s-devis-formulaire]'),
      totaux: q('[data-s-devis-totaux]'),
      tarifs: q('[data-s-devis-tarifs]'),
      statut: q('[data-s-devis-statut]'),
      erreur: q('[data-s-devis-erreur]'),
      envoyer: q('[data-s-devis-envoyer]'),
      envoyerTexte: q('[data-s-devis-envoyer-texte]'),
      turnstile: q('[data-s-devis-turnstile]'),
      caseFacturation: q('[data-s-devis-facturation-case]'),
      blocFacturation: q('[data-s-devis-facturation]'),
    };

    const euros = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
    const prix = (x) => euros.format(Number(x) || 0).replace(/[  ]/g, ' ');
    const pourcent = (taux) => `${String(Math.round(taux * 1000) / 10).replace('.', ',')} %`;
    const pluriel = (n, mot) => `${n} ${mot}${n > 1 ? 's' : ''}`;
    const lignesDe = (texte) => String(texte || '').split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
    const DERNIER = 'sesames-devis-dernier';

    /* Petit constructeur d'éléments : le texte passe toujours par textContent */
    const h = (balise, attributs, ...enfants) => {
      const noeud = document.createElement(balise);
      Object.entries(attributs || {}).forEach(([cle, valeur]) => {
        if (valeur === null || valeur === undefined || valeur === false) return;
        if (cle === 'classe') noeud.className = valeur;
        else noeud.setAttribute(cle, valeur === true ? '' : valeur);
      });
      enfants.flat().forEach((enfant) => {
        if (enfant === null || enfant === undefined || enfant === false) return;
        noeud.append(enfant instanceof Node ? enfant : document.createTextNode(String(enfant)));
      });
      return noeud;
    };

    const etat = {
      calcul: null,
      numero: 0,
      minuterie: null,
      tarif: null,
      indisponibles: new Set(),
      panne: false,
      envoi: false,
      resultat: false,
      ids: '',
      prepare: false,
      jeton: '',
      attente: [],
      widget: null,
      turnstileKo: false,
      codes: [],
    };

    /* ---------- Relais ---------- */

    async function relais(chemin, corps) {
      const controle = 'AbortController' in window ? new AbortController() : null;
      const minuterie = controle ? setTimeout(() => controle.abort(), 30000) : null;
      let reponse;
      try {
        reponse = await fetch(String(R.relais || '').replace(/\/+$/, '') + chemin, {
          method: corps ? 'POST' : 'GET',
          headers: corps ? { 'Content-Type': 'application/json' } : {},
          body: corps ? JSON.stringify(corps) : undefined,
          credentials: 'omit',
          signal: controle ? controle.signal : undefined,
        });
      } catch (erreur) {
        const e = new Error('');
        e.reseau = true;
        throw e;
      } finally {
        if (minuterie) clearTimeout(minuterie);
      }
      let donnees = {};
      try {
        donnees = await reponse.json();
      } catch (erreur) { /* réponse vide */ }
      if (!reponse.ok) {
        const e = new Error(donnees.erreur || '');
        e.statut = reponse.status;
        e.donnees = donnees;
        throw e;
      }
      return donnees;
    }

    /* ---------- Affichage de la sélection ---------- */

    function afficher() {
      if (etat.resultat) return;
      const lignes = Devis.lire();
      el.chargement.hidden = true;
      if (!lignes.length) {
        el.grille.hidden = true;
        el.vide.hidden = false;
        afficherDernier();
        etat.ids = '';
        return;
      }
      el.vide.hidden = true;
      el.grille.hidden = false;
      const ids = lignes.map((l) => l.variantId).join(',');
      if (ids !== etat.ids) {
        rendreLignes(lignes);
        etat.ids = ids;
      } else {
        lignes.forEach((l) => {
          const champ = q(`[data-ligne][data-variant="${l.variantId}"] [data-quantite]`);
          if (champ && document.activeElement !== champ) champ.value = l.quantite;
        });
      }
      preparer();
      planifierCalcul();
    }

    function rendreLignes(lignes) {
      el.lignes.textContent = '';
      lignes.forEach((l) => {
        const li = el.modele.content.firstElementChild.cloneNode(true);
        const nomComplet = `${l.titre || 'Article'}${l.variante ? ` (${l.variante})` : ''}`;
        li.dataset.variant = l.variantId;
        const image = q('[data-image]', li);
        if (l.image) {
          image.src = l.image;
        } else {
          image.parentElement.classList.add('is-vide');
          image.remove();
        }
        const titre = q('[data-titre]', li);
        titre.textContent = l.titre || 'Article';
        if (l.url) titre.href = l.url;
        else titre.removeAttribute('href');
        q('[data-variante]', li).textContent = l.variante ? `Format : ${l.variante}` : '';
        q('[data-unite]', li).textContent = Number.isFinite(l.prix) ? `${prix(l.prix / 100)} l’unité` : '';
        const champ = q('[data-quantite]', li);
        champ.value = l.quantite;
        champ.id = `SesamesDevisQuantite-${l.variantId}`;
        champ.setAttribute('aria-label', `Quantité : ${nomComplet}`);
        q('[data-moins]', li).textContent = `Un exemplaire de moins : ${nomComplet}`;
        q('[data-plus]', li).textContent = `Un exemplaire de plus : ${nomComplet}`;
        q('[data-retirer]', li).setAttribute('aria-label', `Retirer du devis : ${nomComplet}`);
        q('[data-total]', li).textContent = Number.isFinite(l.prix) ? prix((l.prix * l.quantite) / 100) : '';
        el.lignes.append(li);
      });
      marquerIndisponibles();
    }

    function majLignes(lignesCalculees) {
      (lignesCalculees || []).forEach((l) => {
        const li = q(`[data-ligne][data-variant="${l.variantId}"]`);
        if (!li) return;
        q('[data-unite]', li).textContent = `${prix(l.prixUnitaire)} l’unité`;
        q('[data-total]', li).textContent = prix(l.total);
        const titre = q('[data-titre]', li);
        if (!titre.textContent || titre.textContent === 'Article') titre.textContent = l.titre;
        const variante = q('[data-variante]', li);
        if (!variante.textContent && l.variante) variante.textContent = `Format : ${l.variante}`;
      });
    }

    function marquerIndisponibles() {
      qa('[data-ligne]', el.lignes).forEach((li) => {
        const absent = etat.indisponibles.has(li.dataset.variant);
        li.classList.toggle('is-indisponible', absent);
        q('[data-alerte]', li).hidden = !absent;
      });
    }

    el.lignes.addEventListener('change', (evenement) => {
      const champ = evenement.target.closest('[data-quantite]');
      if (!champ) return;
      let valeur = parseInt(champ.value, 10);
      if (!(valeur >= 1)) valeur = 1;
      if (valeur > 999) valeur = 999;
      champ.value = valeur;
      Devis.quantite(champ.closest('[data-ligne]').dataset.variant, valeur);
    });

    el.lignes.addEventListener('click', (evenement) => {
      const bouton = evenement.target.closest('[data-retirer]');
      if (!bouton) return;
      const li = bouton.closest('[data-ligne]');
      const titre = q('[data-titre]', li).textContent;
      const voisin = li.nextElementSibling || li.previousElementSibling;
      const idVoisin = voisin ? voisin.dataset.variant : null;
      etat.indisponibles.delete(li.dataset.variant);
      Devis.retirer(li.dataset.variant);
      annoncer(`« ${titre} » est retiré du devis.`);
      const cible = idVoisin ? q(`[data-ligne][data-variant="${idVoisin}"] [data-retirer]`) : null;
      if (cible) cible.focus();
      else {
        const titreVide = q('[data-s-devis-vide] h2');
        if (titreVide) {
          titreVide.setAttribute('tabindex', '-1');
          titreVide.focus();
        }
      }
    });

    /* ---------- Préparation du formulaire (une fois) ---------- */

    function preparer() {
      if (etat.prepare) return;
      etat.prepare = true;
      remplirPays();
      preparerTurnstile();

      const pays = q('#SesamesDevis-pays');
      if (pays) {
        pays.addEventListener('change', () => {
          etat.tarif = null;
          planifierCalcul(0);
        });
      }
      el.caseFacturation.addEventListener('change', () => {
        const actif = el.caseFacturation.checked;
        el.blocFacturation.hidden = !actif;
        el.blocFacturation.disabled = !actif;
        if (actif) {
          const premier = q('#SesamesDevis-f_organisme');
          if (premier) premier.focus();
        }
      });
      el.tarifs.addEventListener('change', (evenement) => {
        if (evenement.target.name !== 'tarif') return;
        etat.tarif = evenement.target.value;
        planifierCalcul(0);
      });
      el.form.addEventListener('input', (evenement) => {
        if (evenement.target.getAttribute('aria-invalid') === 'true') marquerChamp(evenement.target, '');
      });
      el.form.addEventListener('submit', envoyer);
    }

    async function remplirPays() {
      const listes = qa('select[data-pays]');
      if (!listes.length) return;
      let codes = [];
      try {
        codes = (await relais('/pays')).pays || [];
      } catch (erreur) {
        return; /* la France reste proposée */
      }
      if (!codes.length) return;
      let noms = null;
      try {
        noms = new Intl.DisplayNames(['fr'], { type: 'region' });
      } catch (erreur) { /* navigateur ancien : codes affichés */ }
      const nom = (code) => {
        try {
          return (noms && noms.of(code)) || code;
        } catch (erreur) {
          return code;
        }
      };
      const disponibles = new Set(codes);
      const proches = ['BE', 'BL', 'CA', 'CH', 'GF', 'GP', 'LU', 'MC', 'MF', 'MQ', 'NC', 'PF', 'PM', 'RE', 'WF', 'YT']
        .filter((code) => disponibles.has(code))
        .sort((a, b) => nom(a).localeCompare(nom(b), 'fr'));
      const autres = codes
        .filter((code) => code !== 'FR' && !proches.includes(code))
        .sort((a, b) => nom(a).localeCompare(nom(b), 'fr'));
      listes.forEach((liste) => {
        const actuel = liste.value || 'FR';
        liste.textContent = '';
        if (disponibles.has('FR')) liste.append(new Option('France', 'FR'));
        const groupe1 = h('optgroup', { label: 'Outre-mer et pays francophones' });
        proches.forEach((code) => groupe1.append(new Option(nom(code), code)));
        const groupe2 = h('optgroup', { label: 'Autres pays' });
        autres.forEach((code) => groupe2.append(new Option(nom(code), code)));
        liste.append(groupe1, groupe2);
        liste.value = disponibles.has(actuel) ? actuel : 'FR';
      });
    }

    /* ---------- Calcul ---------- */

    function planifierCalcul(delai = 350) {
      clearTimeout(etat.minuterie);
      racine.classList.add('is-calcul');
      etat.minuterie = setTimeout(calculer, delai);
    }

    async function calculer() {
      const lignes = Devis.lire();
      if (!lignes.length) return;
      const numero = (etat.numero += 1);
      el.totaux.setAttribute('aria-busy', 'true');
      try {
        const d = await relais('/calcul', {
          lignes: lignes.map(({ variantId, quantite }) => ({ variantId, quantite })),
          livraison: { pays: valeur('pays') || 'FR' },
          tarif: etat.tarif,
        });
        if (numero !== etat.numero) return;
        etat.calcul = d;
        etat.panne = false;
        etat.indisponibles = new Set();
        etat.tarif = d.tarif;
        marquerIndisponibles();
        majLignes(d.lignes);
        rendreTarifs(d);
        rendreTotaux(d);
      } catch (erreur) {
        if (numero !== etat.numero) return;
        etat.calcul = null;
        if (erreur.donnees && Array.isArray(erreur.donnees.indisponibles)) {
          etat.indisponibles = new Set(erreur.donnees.indisponibles.map(String));
          marquerIndisponibles();
          rendreMessageTotaux(erreur.message, 'alerte');
        } else if (erreur.reseau || erreur.statut >= 500) {
          etat.panne = true;
          rendreRepli();
        } else {
          rendreMessageTotaux(erreur.message || 'Le devis n’a pas pu être calculé.', 'alerte');
        }
      } finally {
        if (numero === etat.numero) {
          racine.classList.remove('is-calcul');
          el.totaux.removeAttribute('aria-busy');
        }
      }
    }

    function rendreTarifs(d) {
      el.tarifs.textContent = '';
      if (!d.expedition) {
        el.tarifs.append(h('p', { classe: 's-devis__tarif-texte' }, 'Articles numériques : rien à livrer.'));
        return;
      }
      if (!d.livrable) {
        el.tarifs.append(h('p', { classe: 's-devis__tarif-alerte' },
          'Nous ne livrons pas encore ce pays sur devis. Écrivez-nous à ',
          h('a', { href: `mailto:${R.email}` }, R.email),
          ' : nous chercherons une solution.'));
        return;
      }
      if (d.tarifs.length === 1) {
        el.tarifs.append(h('p', { classe: 's-devis__tarif-texte' },
          'Livraison : ', h('strong', null, d.tarifs[0].titre), `, ${prix(d.tarifs[0].prix)}`));
        return;
      }
      const groupe = h('fieldset', { classe: 's-devis__tarifs-choix' }, h('legend', null, 'Mode de livraison'));
      d.tarifs.forEach((t, i) => {
        const id = `SesamesDevisTarif-${i}`;
        groupe.append(h('div', { classe: 's-devis__tarif' },
          h('input', { type: 'radio', id, name: 'tarif', value: t.handle, checked: t.handle === d.tarif }),
          h('label', { for: id }, t.titre, h('span', { classe: 's-devis__tarif-prix' }, prix(t.prix)))));
      });
      el.tarifs.append(groupe);
    }

    function rendreTotaux(d) {
      const t = d.totaux;
      const exemplaires = d.lignes.reduce((s, l) => s + l.quantite, 0);
      const tarif = (d.tarifs || []).find((x) => x.handle === d.tarif);
      const sansTva = !(t.tva > 0); /* livraison hors UE : prix hors taxe, aucune TVA */
      const ligne = (classe, libelle, precision, montant) => h('div', { classe: `s-devis__total ${classe || ''}` },
        h('dt', null, libelle, precision ? h('span', { classe: 's-devis__total-precision' }, ` ${precision}`) : null),
        h('dd', null, montant));
      const liste = h('dl', { classe: 's-devis__totaux-liste' },
        ligne('', 'Sous-total', `(${pluriel(exemplaires, 'exemplaire')})`, prix(t.sousTotal)),
        d.expedition
          ? ligne('', 'Livraison', tarif ? `(${tarif.titre})` : '', d.livrable ? prix(t.port) : 'à définir')
          : null,
        ligne('s-devis__total--ttc', sansTva ? 'Total HT' : 'Total TTC', '', prix(t.ttc)),
        ...(sansTva
          ? [ligne('s-devis__total--detail', 'TVA', '', 'non applicable')]
          : [
            ...(d.tva || []).filter((x) => x.montant > 0)
              .map((x) => ligne('s-devis__total--detail', `dont TVA ${pourcent(x.taux)}`, '', prix(x.montant))),
            ligne('s-devis__total--detail', 'Total HT', '', prix(t.ht)),
          ]));
      el.totaux.textContent = '';
      el.totaux.append(liste);
    }

    function rendreMessageTotaux(message, type) {
      el.totaux.textContent = '';
      el.totaux.append(h('p', { classe: `s-devis__totaux-message s-devis__totaux-message--${type}` }, message));
    }

    function rendreRepli() {
      el.totaux.textContent = '';
      el.totaux.append(h('div', { classe: 's-devis__repli' },
        h('p', null, h('strong', null, 'Le calcul en ligne ne répond pas pour le moment.')),
        h('p', null, 'Envoyez-nous votre sélection par e-mail : nous vous répondrons avec votre devis.'),
        h('p', null, h('a', { classe: 's-btn s-btn--secondaire s-btn--pleine-largeur', href: lienEmail() }, 'Envoyer ma sélection par e-mail')),
        h('p', { classe: 's-devis__repli-adresse' }, 'Adresse : ', h('strong', null, R.email))));
    }

    function lienEmail() {
      const lignes = Devis.lire().map((l) => `- ${l.quantite} × ${l.titre}${l.variante ? ` (${l.variante})` : ''}`);
      const infos = [
        ['Établissement', valeur('etablissement')],
        ['Contact', [valeur('prenom'), valeur('nom')].filter(Boolean).join(' ')],
        ['Adresse de livraison', [valeur('adresse1'), valeur('adresse2'), `${valeur('cp')} ${valeur('ville')}`.trim()].filter(Boolean).join(', ')],
        ['Téléphone', valeur('telephone')],
      ];
      const corps = [
        'Bonjour,', '', 'Je souhaite recevoir un devis pour :', ...lignes, '',
        ...infos.map(([libelle, v]) => `${libelle} : ${v || ''}`), '', 'Merci.',
      ].join('\n');
      return `mailto:${R.email}?subject=${encodeURIComponent('Demande de devis')}&body=${encodeURIComponent(corps)}`;
    }

    /* ---------- Formulaire ---------- */

    const inactif = (champ) => (typeof champ.matches === 'function' ? champ.matches(':disabled') : !!champ.disabled);

    function valeur(nom) {
      const champ = el.form.elements[nom];
      return champ && !inactif(champ) ? String(champ.value || '').trim() : '';
    }

    function marquerChamp(champ, message) {
      const idErreur = `${champ.id}-erreur`;
      const erreur = document.getElementById(idErreur);
      const decrit = (champ.getAttribute('aria-describedby') || '').split(' ').filter((x) => x && x !== idErreur);
      if (message) {
        champ.setAttribute('aria-invalid', 'true');
        decrit.push(idErreur);
        if (erreur) {
          erreur.textContent = message;
          erreur.hidden = false;
        }
      } else {
        champ.removeAttribute('aria-invalid');
        if (erreur) {
          erreur.textContent = '';
          erreur.hidden = true;
        }
      }
      if (decrit.length) champ.setAttribute('aria-describedby', decrit.join(' '));
      else champ.removeAttribute('aria-describedby');
    }

    function controler() {
      const invalides = [];
      qa('[required]', el.form).forEach((champ) => {
        if (inactif(champ)) return;
        const v = String(champ.value || '').trim();
        let ok = v !== '';
        if (ok && champ.type === 'email') ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
        marquerChamp(champ, ok ? '' : champ.dataset.message || 'Ce champ est à remplir.');
        if (!ok) invalides.push(champ);
      });
      return invalides;
    }

    function erreur(message) {
      el.erreur.textContent = '';
      if (message) el.erreur.append(h('p', null, message));
    }

    function annoncer(message) {
      el.statut.textContent = message || '';
    }

    function occupe(actif, texte) {
      etat.envoi = actif;
      el.envoyer.disabled = actif;
      el.envoyer.classList.toggle('is-occupe', actif);
      el.envoyerTexte.textContent = actif ? texte : 'Obtenir mon devis PDF';
    }

    async function envoyer(evenement) {
      evenement.preventDefault();
      if (etat.envoi) return;
      erreur('');
      const invalides = controler();
      if (invalides.length) {
        erreur(invalides.length > 1
          ? `${invalides.length} champs sont à compléter : ils sont signalés dans le formulaire.`
          : 'Un champ est à compléter : il est signalé dans le formulaire.');
        invalides[0].focus();
        return;
      }
      if (etat.panne) {
        rendreRepli();
        erreur('Le calcul en ligne ne répond pas : envoyez-nous votre sélection par e-mail.');
        return;
      }
      if (etat.indisponibles.size) {
        erreur('Retirez d’abord les articles qui ne sont plus disponibles.');
        return;
      }
      if (!etat.calcul) {
        erreur('Le devis est en cours de calcul : réessayez dans un instant.');
        planifierCalcul(0);
        return;
      }
      if (etat.calcul.expedition && !etat.calcul.livrable) {
        erreur(`Nous ne livrons pas encore ce pays sur devis : écrivez-nous à ${R.email}.`);
        return;
      }

      // Sans jeton (vérification qui n'aboutit pas), la demande part quand même : le relais fait un devis de secours
      occupe(true, 'Vérification anti-robots…');
      const jeton = await obtenirJeton();

      occupe(true, 'Préparation du devis…');
      const facturer = el.caseFacturation.checked;
      const corps = {
        lignes: Devis.lire().map(({ variantId, quantite }) => ({ variantId, quantite })),
        client: {
          etablissement: valeur('etablissement'),
          prenom: valeur('prenom'),
          nom: valeur('nom'),
          email: valeur('email'),
          telephone: valeur('telephone'),
        },
        livraison: { adresse1: valeur('adresse1'), adresse2: valeur('adresse2'), cp: valeur('cp'), ville: valeur('ville'), pays: valeur('pays') || 'FR' },
        facturation: facturer
          ? { autre: true, organisme: valeur('f_organisme'), adresse1: valeur('f_adresse1'), adresse2: valeur('f_adresse2'), cp: valeur('f_cp'), ville: valeur('f_ville'), pays: valeur('f_pays') || 'FR' }
          : { autre: false },
        tarif: etat.calcul.tarif,
        reference: valeur('reference'),
        message: valeur('message'),
        site: el.form.elements.site ? el.form.elements.site.value : '',
        jeton,
        antiRobots: jeton ? undefined : { codes: etat.codes.slice(0, 5) },
        test: R.essai === true,
      };
      try {
        const d = await relais('/devis', corps);
        etat.resultat = true;
        sauverDernier(d);
        Devis.vider();
        afficherResultat(d.devis, { nouveau: true, email: corps.client.email, id: d.id, cle: d.cle });
        telecharger(d.devis);
      } catch (e) {
        if (e.donnees && Array.isArray(e.donnees.indisponibles)) {
          etat.indisponibles = new Set(e.donnees.indisponibles.map(String));
          marquerIndisponibles();
        }
        erreur(e.message || `Le devis n’a pas pu être préparé. Réessayez, ou écrivez-nous à ${R.email}.`);
        if (e.reseau || (e.donnees && e.donnees.ecrire)) el.erreur.append(h('p', null, h('a', { href: lienEmail() }, 'Envoyer ma sélection par e-mail')));
      } finally {
        occupe(false);
        reinitialiserTurnstile();
      }
    }

    /* ---------- Cloudflare Turnstile (anti-robots, invisible sauf doute) ---------- */

    function preparerTurnstile() {
      if (!R.turnstile || !el.turnstile) return;
      window.onSesamesDevisTurnstile = () => {
        try {
          etat.widget = window.turnstile.render(el.turnstile, {
            sitekey: R.turnstile,
            language: 'fr',
            appearance: 'interaction-only',
            action: 'devis',
            callback: (jeton) => {
              etat.jeton = jeton;
              etat.turnstileKo = false;
              etat.attente.splice(0).forEach((f) => f(jeton));
            },
            'expired-callback': () => {
              etat.jeton = '';
            },
            'error-callback': (code) => {
              noterCode(code);
              etat.jeton = '';
              etat.turnstileKo = true;
              etat.attente.splice(0).forEach((f) => f(''));
            },
            'timeout-callback': () => noterCode('délai dépassé'),
            'unsupported-callback': () => noterCode('non pris en charge'),
          });
        } catch (e) {
          noterCode('affichage');
          etat.turnstileKo = true;
        }
      };
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=onSesamesDevisTurnstile';
      script.async = true;
      script.onerror = () => {
        noterCode('script bloqué');
        etat.turnstileKo = true;
        etat.attente.splice(0).forEach((f) => f(''));
      };
      document.head.append(script);
    }

    // Codes d'erreur de Turnstile, joints à une demande partie sans jeton (note de la commande provisoire)
    function noterCode(code) {
      const c = String(code || '').slice(0, 20);
      if (c && !etat.codes.includes(c) && etat.codes.length < 5) etat.codes.push(c);
    }

    function obtenirJeton() {
      if (!R.turnstile) return Promise.resolve('');
      if (etat.jeton) return Promise.resolve(etat.jeton);
      if (etat.turnstileKo && !window.turnstile) return Promise.resolve('');
      return new Promise((resoudre) => {
        etat.attente.push(resoudre);
        setTimeout(() => resoudre(etat.jeton || ''), 10000);      // au-delà, la demande part sans jeton
      });
    }

    function reinitialiserTurnstile() {
      etat.jeton = '';
      if (window.turnstile && etat.widget !== null) {
        try {
          window.turnstile.reset(etat.widget);
        } catch (e) { /* widget retiré */ }
      }
    }

    /* ---------- Résultat, relecture et dernier devis ---------- */

    function sauverDernier(d) {
      try {
        window.localStorage.setItem(DERNIER, JSON.stringify({
          id: d.id, cle: d.cle, numero: d.numero, date: d.devis.dateTexte, validite: d.devis.validiteTexte,
          fin: Date.now() + (d.devis.validiteJours || 30) * 86400000, ttc: d.devis.totaux.ttc,
        }));
      } catch (e) { /* stockage indisponible */ }
    }

    function afficherDernier() {
      let dernier = null;
      try {
        dernier = JSON.parse(window.localStorage.getItem(DERNIER) || 'null');
      } catch (e) { /* rien */ }
      if (!dernier || !dernier.id || !(dernier.fin > Date.now())) {
        el.dernier.hidden = true;
        return;
      }
      const lien = `${window.location.pathname}?devis=${encodeURIComponent(dernier.id)}&cle=${encodeURIComponent(dernier.cle)}`;
      el.dernier.textContent = '';
      el.dernier.append(
        h('p', { classe: 's-encadre__titre' }, `Votre dernier devis : n° ${dernier.numero}`),
        h('p', null, `Établi le ${dernier.date}, valable jusqu’au ${dernier.validite}, ${prix(dernier.ttc)} TTC. `,
          h('a', { href: lien }, 'Revoir et télécharger ce devis')));
      el.dernier.hidden = false;
    }

    async function relire(id, cle) {
      etat.resultat = true;
      el.chargement.hidden = false;
      el.chargement.textContent = 'Chargement du devis…';
      try {
        const d = await relais(`/devis/${encodeURIComponent(id)}?cle=${encodeURIComponent(cle)}`);
        el.chargement.hidden = true;
        afficherResultat(d.devis, { nouveau: false });
      } catch (e) {
        el.chargement.hidden = true;
        el.resultat.textContent = '';
        el.resultat.append(h('div', { classe: 's-encadre s-encadre--alerte' },
          h('h2', { classe: 's-encadre__titre' }, 'Ce devis n’a pas pu être affiché'),
          h('p', null, e.message || 'Le service de devis ne répond pas pour le moment. Réessayez dans un instant.'),
          h('p', null, 'Besoin d’aide ? Écrivez-nous à ', h('a', { href: `mailto:${R.email}` }, R.email), '.'),
          h('p', null, h('a', { classe: 's-lien-fleche', href: window.location.pathname }, 'Revenir à mon devis'))));
        el.resultat.hidden = false;
      }
    }

    function afficherResultat(d, options) {
      el.grille.hidden = true;
      el.vide.hidden = true;
      el.chargement.hidden = true;
      const boutonPdf = h('button', { type: 'button', classe: 's-btn s-btn--principal s-devis__pdf' }, 'Télécharger le devis (PDF)');
      const statutPdf = h('p', { classe: 's-devis__pdf-statut', role: 'status', 'data-s-devis-pdf-statut': true });
      boutonPdf.addEventListener('click', () => telecharger(d, boutonPdf));

      const sansTva = !(d.totaux.tva > 0);
      const detail = h('table', { classe: 's-devis__detail-table' },
        h('caption', { classe: 'visually-hidden' }, `Détail du devis n° ${d.numero}`),
        h('thead', null, h('tr', null,
          h('th', { scope: 'col' }, 'Article'), h('th', { scope: 'col' }, 'Qté'), h('th', { scope: 'col' }, sansTva ? 'Total HT' : 'Total TTC'))),
        h('tbody', null,
          d.lignes.map((l) => h('tr', null,
            h('td', null, l.titre, l.variante ? h('span', { classe: 's-devis__detail-variante' }, l.variante) : null),
            h('td', null, String(l.quantite)), h('td', null, prix(l.totalTTC)))),
          d.port ? h('tr', null, h('td', null, `Livraison : ${d.port.titre}`), h('td', null, '1'), h('td', null, prix(d.port.totalTTC))) : null),
        h('tfoot', null, sansTva
          ? [
            h('tr', null, h('th', { scope: 'row', colspan: '2' }, 'TVA'), h('td', null, 'non applicable')),
            h('tr', { classe: 's-devis__detail-ttc' }, h('th', { scope: 'row', colspan: '2' }, 'Total HT'), h('td', null, prix(d.totaux.ht))),
          ]
          : [
            h('tr', null, h('th', { scope: 'row', colspan: '2' }, 'Total HT'), h('td', null, prix(d.totaux.ht))),
            h('tr', null, h('th', { scope: 'row', colspan: '2' }, 'TVA'), h('td', null, prix(d.totaux.tva))),
            h('tr', { classe: 's-devis__detail-ttc' }, h('th', { scope: 'row', colspan: '2' }, 'Total TTC'), h('td', null, prix(d.totaux.ttc))),
          ]));

      el.resultat.textContent = '';
      el.resultat.append(
        h('div', { classe: 's-devis__succes' },
          h('p', { classe: 's-surtitre' }, `Devis n° ${d.numero}`),
          h('h2', { classe: 's-devis__succes-titre' }, options.nouveau ? 'Votre devis est prêt' : `Votre devis du ${d.dateTexte}`),
          h('p', null, `Établi le ${d.dateTexte}${d.client.etablissement ? ` pour ${d.client.etablissement}` : ''}, valable jusqu’au ${d.validiteTexte}. Montant : `,
            h('strong', null, `${prix(d.totaux.ttc)} ${sansTva ? 'HT' : 'TTC'}`), '.'),
          h('div', { classe: 's-devis__succes-actions' }, boutonPdf),
          statutPdf,
          options.nouveau && d.emailEnvoye ? h('p', null, `Nous vous l’avons aussi envoyé par e-mail, à ${options.email}.`) : null),
        h('div', { classe: 's-devis__suite' },
          h('h2', { classe: 's-devis__suite-titre' }, 'Pour commander'),
          h('ol', { classe: 's-devis__etapes', role: 'list' },
            h('li', null, h('strong', null, 'Faites signer le devis'), ' : date, signature et cachet de l’établissement, dans la zone « Bon pour accord ».'),
            h('li', null, h('strong', null, 'Renvoyez-le'), ' à ', h('a', { href: `mailto:${R.email}` }, R.email),
              `, ou envoyez votre bon de commande en rappelant le n° ${d.numero}.`),
            h('li', null, h('strong', null, 'Nous expédions'), ' sous 24 à 48 heures ouvrées après réception.')),
          d.lienCommande
            ? h('p', { classe: 's-devis__en-ligne' }, 'Vous préférez commander directement en ligne, sans renvoyer le devis signé ? ',
              h('a', { href: d.lienCommande }, 'Cliquez sur ce lien pour commander les articles de ce devis'), '.')
            : null),
        h('details', { classe: 's-devis__detail' }, h('summary', null, 'Détail du devis'), detail),
        h('p', { classe: 's-devis__fin' },
          h('a', { classe: 's-lien-fleche', href: R.catalogue || '/collections/all' }, 'Retour au catalogue')));
      el.resultat.hidden = false;
      el.resultat.focus({ preventScroll: true });
      el.resultat.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      /* Après l'envoi, l'adresse de la page devient celle du devis : un rechargement le réaffiche */
      if (options.nouveau && options.id && window.history && window.history.replaceState) {
        try {
          const adresse = new URL(window.location.href);
          adresse.searchParams.set('devis', options.id);
          adresse.searchParams.set('cle', options.cle);
          window.history.replaceState(null, '', adresse.toString());
        } catch (e) { /* adresse inchangée */ }
      }
    }

    /* ---------- PDF (jsPDF) ---------- */

    const JSPDF = {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/4.2.1/jspdf.umd.min.js',
      integrite: 'sha512-plOdviVmws4Y3JAvbnpfKb2hVxKM1lCwsi3vmElYRj+tiDLffZ4FVUj5a8vyKJ9pIgl8JCAHEJ4D1iUKBecswg==',
    };
    let chargementJsPdf = null;
    let logo = null;

    function chargerJsPdf() {
      if (window.jspdf && window.jspdf.jsPDF) return Promise.resolve(window.jspdf.jsPDF);
      if (!chargementJsPdf) {
        chargementJsPdf = new Promise((resoudre, rejeter) => {
          const script = document.createElement('script');
          script.src = JSPDF.src;
          script.integrity = JSPDF.integrite;
          script.crossOrigin = 'anonymous';
          script.referrerPolicy = 'no-referrer';
          script.onload = () => (window.jspdf && window.jspdf.jsPDF ? resoudre(window.jspdf.jsPDF) : rejeter(new Error('jsPDF')));
          script.onerror = () => {
            chargementJsPdf = null;
            rejeter(new Error('jsPDF'));
          };
          document.head.append(script);
        });
      }
      return chargementJsPdf;
    }

    async function chargerLogo() {
      if (logo !== null) return logo;
      try {
        const image = new Image();
        await new Promise((resoudre, rejeter) => {
          image.onload = resoudre;
          image.onerror = rejeter;
          image.src = R.logo;
        });
        const largeur = 1000;
        const ratio = (image.naturalHeight || 758.52) / (image.naturalWidth || 1922.35);
        const toile = document.createElement('canvas');
        toile.width = largeur;
        toile.height = Math.round(largeur * ratio);
        toile.getContext('2d').drawImage(image, 0, 0, toile.width, toile.height);
        logo = { donnees: toile.toDataURL('image/png'), ratio };
      } catch (e) {
        logo = false;
      }
      return logo;
    }

    /* Vignette d'un article pour le PDF : image Shopify posée sur un carré blanc, en JPEG. Sans image, ou en cas
       d'échec ou de lenteur, la ligne du devis reste sans vignette. */
    const vignettes = new Map();

    function chargerVignette(url) {
      if (!url) return Promise.resolve(null);
      if (!vignettes.has(url)) {
        vignettes.set(url, new Promise((resoudre) => {
          const image = new Image();
          const minuterie = setTimeout(() => resoudre(null), 6000);
          image.crossOrigin = 'anonymous';
          image.onload = () => {
            clearTimeout(minuterie);
            try {
              const cote = 240;
              const toile = document.createElement('canvas');
              toile.width = cote;
              toile.height = cote;
              const contexte = toile.getContext('2d');
              contexte.fillStyle = '#ffffff';
              contexte.fillRect(0, 0, cote, cote);
              const echelle = Math.min(cote / image.naturalWidth, cote / image.naturalHeight);
              const largeur = image.naturalWidth * echelle;
              const hauteur = image.naturalHeight * echelle;
              contexte.drawImage(image, (cote - largeur) / 2, (cote - hauteur) / 2, largeur, hauteur);
              resoudre(toile.toDataURL('image/jpeg', 0.88));
            } catch (e) {
              resoudre(null);
            }
          };
          image.onerror = () => {
            clearTimeout(minuterie);
            resoudre(null);
          };
          image.src = url;
        }));
      }
      return vignettes.get(url);
    }

    async function telecharger(d, bouton) {
      const statut = q('[data-s-devis-pdf-statut]');
      if (bouton) bouton.disabled = true;
      if (statut) statut.textContent = 'Préparation du PDF…';
      try {
        const [JsPDF, image, images] = await Promise.all([
          chargerJsPdf(),
          chargerLogo(),
          Promise.all((d.lignes || []).map((l) => chargerVignette(l.image))),
        ]);
        construirePdf(JsPDF, d, image, images).save(`Devis-${d.numero}-Les-editions-Sesames.pdf`);
        if (statut) statut.textContent = 'Le devis PDF est enregistré dans vos téléchargements.';
      } catch (e) {
        if (statut) statut.textContent = `Le PDF n’a pas pu être préparé. Réessayez, ou écrivez-nous à ${R.email} en rappelant le n° ${d.numero}.`;
      } finally {
        if (bouton) bouton.disabled = false;
      }
    }

    function construirePdf(JsPDF, d, image, images = []) {
      const C = {
        encre: [46, 42, 57], encre2: [91, 85, 102], encre3: [107, 101, 118], magenta: [218, 22, 118],
        bleu: [16, 111, 183], trait: [228, 223, 230], fond: [247, 244, 246], blanc: [255, 255, 255],
      };
      const doc = new JsPDF({ unit: 'mm', format: 'a4', compress: true });
      const sansTva = !(d.totaux.tva > 0); /* livraison hors UE : prix hors taxe, « TVA non applicable » */
      const L = 210;
      const H = 297;
      const M = 16;
      const LU = L - 2 * M;
      const BAS = H - 20;
      const PT = 0.3528;
      /* Polices standard du PDF (Helvetica) : espaces fines remplacées par des espaces insécables ordinaires */
      const propre = (t) => String(t === null || t === undefined ? '' : t).replace(/[   ]/g, ' ').replace(/[​⁠﻿]/g, '');
      const police = (taille, gras, couleur) => {
        doc.setFont('helvetica', gras ? 'bold' : 'normal');
        doc.setFontSize(taille);
        doc.setTextColor(...(couleur || C.encre));
      };
      const interligne = (taille, facteur = 1.3) => taille * PT * facteur;
      const couper = (texte, largeur, taille, gras) => {
        police(taille, gras);
        return doc.splitTextToSize(propre(texte), largeur);
      };
      /* Écrit un texte (ou des lignes déjà coupées) ; y est la ligne de base ; renvoie la hauteur occupée */
      const ecrire = (texte, x, y, o = {}) => {
        const taille = o.taille || 9.5;
        const facteur = o.interligne || 1.3;
        police(taille, o.gras, o.couleur);
        let lignes = Array.isArray(texte) ? texte.map(propre) : [propre(texte)];
        if (o.largeur && !Array.isArray(texte)) lignes = doc.splitTextToSize(lignes[0], o.largeur);
        doc.text(lignes, x, y, { align: o.align || 'left', lineHeightFactor: facteur });
        return lignes.length * interligne(taille, facteur);
      };

      doc.setProperties({
        title: `Devis ${d.numero} – Les éditions Sésames`,
        subject: `Devis ${d.numero}`,
        author: 'Les éditions Sésames',
        creator: 'editions-sesames.com',
      });

      /* En-tête : logo et coordonnées de l'éditeur à gauche, numéro et dates à droite */
      let y;
      if (image) {
        doc.addImage(image.donnees, 'PNG', M, 11, 50, 50 * image.ratio);
        y = 11 + 50 * image.ratio + 5;
      } else {
        ecrire('Les éditions Sésames', M, 21, { taille: 18, gras: true, couleur: C.magenta });
        y = 30;
      }
      ecrire('DEVIS', L - M, 21, { taille: 22, gras: true, couleur: C.magenta, align: 'right' });
      ecrire(`N° ${d.numero}`, L - M, 28.5, { taille: 11, gras: true, align: 'right' });
      ecrire(`Date : ${d.dateTexte}`, L - M, 34, { taille: 9, couleur: C.encre2, align: 'right' });
      ecrire(`Valable jusqu’au ${d.validiteTexte}`, L - M, 38.5, { taille: 9, couleur: C.encre2, align: 'right' });
      lignesDe(R.editeur).forEach((ligne, i) => {
        y += ecrire(ligne, M, y, { taille: 8.5, gras: i === 0, couleur: i === 0 ? C.encre : C.encre2 });
      });
      y = Math.max(y, 42) + 4;

      /* Adresses : livraison et facturation (ou adresse unique et contact) */
      const contact = [d.client.contact, d.client.email, d.client.telephone].filter(Boolean);
      const blocs = d.memeAdresse
        ? [{ titre: 'LIVRAISON ET FACTURATION', lignes: d.livraison }, { titre: 'CONTACT', lignes: contact }]
        : [{ titre: 'LIVRAISON', lignes: d.livraison }, { titre: 'FACTURATION', lignes: d.facturation }];
      const largeurBloc = (LU - 6) / 2;
      const coupes = blocs.map((b) => b.lignes.map((l, j) => couper(l, largeurBloc - 8, 9.5, j === 0)));
      const nbLignes = Math.max(...coupes.map((c) => c.reduce((s, l) => s + l.length, 0)), 1);
      const hauteurBloc = 12.5 + nbLignes * interligne(9.5);
      blocs.forEach((b, i) => {
        const x = M + i * (largeurBloc + 6);
        doc.setFillColor(...C.fond);
        doc.roundedRect(x, y, largeurBloc, hauteurBloc, 2, 2, 'F');
        ecrire(b.titre, x + 4, y + 6, { taille: 7.5, gras: true, couleur: C.bleu });
        let yy = y + 11.5;
        coupes[i].forEach((lignes, j) => {
          yy += ecrire(lignes, x + 4, yy, { taille: 9.5, gras: j === 0 });
        });
      });
      y += hauteurBloc + 5;
      if (!d.memeAdresse && contact.length) {
        y += ecrire(`Contact : ${contact.join(' · ')}`, M, y, { taille: 8.5, couleur: C.encre2, largeur: LU });
      }
      if (d.client.reference) {
        y += ecrire(`Votre référence : ${d.client.reference}`, M, y, { taille: 8.5, gras: true, largeur: LU });
      }
      y += 2;

      /* Tableau des articles ; une vignette carrée devant chaque article quand les images ont pu être chargées */
      const VIGNETTE = 13;
      const decalage = images.some(Boolean) ? VIGNETTE + 3 : 0;
      const X = { vignette: M + 2, designation: M + 2 + decalage, qte: M + 107, pu: M + 135, tva: M + 152, total: L - M - 2 };
      const LARGEUR_DESIGNATION = 96 - decalage;
      const enteteTableau = () => {
        doc.setFillColor(...C.bleu);
        doc.rect(M, y, LU, 8, 'F');
        const base = y + 5.3;
        const o = { taille: 8.5, gras: true, couleur: C.blanc };
        ecrire('Désignation', X.vignette, base, o);
        ecrire('Qté', X.qte, base, { ...o, align: 'center' });
        ecrire(sansTva ? 'Prix unit. HT' : 'Prix unit. TTC', X.pu, base, { ...o, align: 'right' });
        ecrire('TVA', X.tva, base, { ...o, align: 'right' });
        ecrire(sansTva ? 'Total HT' : 'Total TTC', X.total, base, { ...o, align: 'right' });
        y += 8;
      };
      const nouvellePage = () => {
        doc.addPage();
        y = 18;
      };
      const ligneTableau = (titre, precision, quantite, unitaire, taux, total, vignette) => {
        const lt = couper(titre, LARGEUR_DESIGNATION, 9, true);
        const lp = precision ? couper(precision, LARGEUR_DESIGNATION, 8, false) : [];
        const hauteurTexte = 2.6 + lt.length * interligne(9) + lp.length * interligne(8) + 2.6;
        const hauteur = vignette ? Math.max(hauteurTexte, VIGNETTE + 4) : hauteurTexte;
        if (y + hauteur > BAS) {
          nouvellePage();
          enteteTableau();
        }
        if (vignette) {
          const yv = y + (hauteur - VIGNETTE) / 2;
          doc.addImage(vignette, 'JPEG', X.vignette, yv, VIGNETTE, VIGNETTE);
          doc.setDrawColor(...C.trait);
          doc.setLineWidth(0.2);
          doc.rect(X.vignette, yv, VIGNETTE, VIGNETTE, 'S');
        }
        const base = y + (hauteur - hauteurTexte) / 2 + 2.6 + 9 * PT;
        let yy = base + ecrire(lt, X.designation, base, { taille: 9, gras: true });
        if (lp.length) ecrire(lp, X.designation, yy - 0.4, { taille: 8, couleur: C.encre2 });
        ecrire(String(quantite), X.qte, base, { taille: 9, align: 'center' });
        ecrire(prix(unitaire), X.pu, base, { taille: 9, align: 'right' });
        ecrire(taux ? pourcent(taux) : '–', X.tva, base, { taille: 9, align: 'right', couleur: C.encre2 });
        ecrire(prix(total), X.total, base, { taille: 9, gras: true, align: 'right' });
        y += hauteur;
        doc.setDrawColor(...C.trait);
        doc.setLineWidth(0.25);
        doc.line(M, y, L - M, y);
      };
      enteteTableau();
      d.lignes.forEach((l, i) => {
        const reference = l.reference && l.reference !== l.variante ? `Réf. ${l.reference}` : '';
        ligneTableau(l.titre, [l.variante, reference].filter(Boolean).join(' · '), l.quantite, l.prixUnitaireTTC, l.tauxTVA, l.totalTTC, images[i]);
      });
      if (d.port) ligneTableau(`Frais de port : ${d.port.titre}`, '', 1, d.port.totalTTC, d.port.tauxTVA, d.port.totalTTC);

      /* Totaux (à droite) et conditions (à gauche) */
      y += 5;
      const conditions = [`Devis valable ${d.validiteJours} jours, jusqu’au ${d.validiteTexte}.`, ...lignesDe(R.conditions)];
      const coupesConditions = conditions.map((c) => couper(c, 86, 8, false));
      const hauteurConditions = 6 + coupesConditions.reduce((s, c) => s + c.length * interligne(8, 1.35) + 1, 0);
      const totaux = sansTva ? [['TVA', 'non applicable']] : [['Total HT', d.totaux.ht]];
      if (!sansTva && d.tvaParTaux && d.tvaParTaux.length) d.tvaParTaux.forEach((t) => totaux.push([`TVA ${pourcent(t.taux)} sur ${prix(t.base)}`, t.montant]));
      else if (!sansTva) totaux.push(['TVA', d.totaux.tva]);
      const hauteurTotaux = totaux.length * 6 + 12;
      if (y + Math.max(hauteurConditions, hauteurTotaux) > BAS) nouvellePage();
      const xTotaux = L - M - 82;
      let yt = y;
      totaux.forEach(([libelle, montant]) => {
        ecrire(libelle, xTotaux + 3, yt, { taille: 9, couleur: C.encre2 });
        ecrire(typeof montant === 'number' ? prix(montant) : montant, L - M - 3, yt, { taille: 9, align: 'right' });
        yt += 6;
      });
      doc.setFillColor(...C.magenta);
      doc.roundedRect(xTotaux, yt - 3.6, 82, 10, 1.5, 1.5, 'F');
      ecrire(sansTva ? 'Total HT' : 'Total TTC', xTotaux + 3, yt + 2.9, { taille: 11, gras: true, couleur: C.blanc });
      ecrire(prix(d.totaux.ttc), L - M - 3, yt + 2.9, { taille: 11, gras: true, couleur: C.blanc, align: 'right' });
      yt += 10;
      let yc = y;
      yc += ecrire('Conditions', M, yc, { taille: 9, gras: true }) + 0.6;
      coupesConditions.forEach((lignes) => {
        yc += ecrire(lignes, M, yc, { taille: 8, couleur: C.encre2, interligne: 1.35 }) + 1;
      });
      y = Math.max(yt, yc) + 4;

      /* Bon pour accord, puis consigne pour commander */
      const consigne = couper(String(R.commander || '').replace(/\[numero\]/g, d.numero), LU, 8.5, false);
      const hauteurAccord = 36;
      if (y + hauteurAccord + 5 + consigne.length * interligne(8.5) > BAS) nouvellePage();
      doc.setDrawColor(...C.bleu);
      doc.setLineWidth(0.4);
      doc.roundedRect(M, y, LU, hauteurAccord, 2, 2, 'S');
      ecrire('Bon pour accord', M + 5, y + 7, { taille: 10, gras: true, couleur: C.bleu });
      ecrire('Date :', M + 5, y + 15, { taille: 8.5, couleur: C.encre2 });
      ecrire('Nom et qualité du signataire :', M + 5, y + 24, { taille: 8.5, couleur: C.encre2 });
      ecrire('Cachet de l’établissement et signature :', M + LU / 2 + 2, y + 15, { taille: 8.5, couleur: C.encre2 });
      y += hauteurAccord + 5;
      if (consigne.length) ecrire(consigne, M, y, { taille: 8.5 });

      /* Pied de page : mentions légales et numéro de page */
      const pages = doc.getNumberOfPages();
      const mentions = lignesDe(R.mentions);
      for (let i = 1; i <= pages; i += 1) {
        doc.setPage(i);
        doc.setDrawColor(...C.trait);
        doc.setLineWidth(0.3);
        doc.line(M, H - 17, L - M, H - 17);
        mentions.forEach((m, j) => ecrire(m, L / 2, H - 12.5 + j * 3.4, { taille: 7, couleur: C.encre3, align: 'center' }));
        if (pages > 1) {
          ecrire(`Page ${i} / ${pages}`, L - M, H - 5.5, { taille: 7, couleur: C.encre3, align: 'right' });
          if (i > 1) ecrire(`Devis n° ${d.numero} (suite)`, M, 11, { taille: 8, couleur: C.encre3 });
        }
      }
      return doc;
    }

    /* ---------- Démarrage ---------- */

    document.addEventListener('sesames:devis', afficher);
    const parametres = new URLSearchParams(window.location.search);
    if (parametres.get('devis') && parametres.get('cle')) relire(parametres.get('devis'), parametres.get('cle'));
    else afficher();
  }
})();
